import { render, staticRenderFns } from "./TreatmentPPSList.vue?vue&type=template&id=9bd8bec2&scoped=true&"
import script from "./TreatmentPPSList.vue?vue&type=script&lang=js&"
export * from "./TreatmentPPSList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9bd8bec2",
  null
  
)

export default component.exports